import { Form, Input, ModalProps, FormProps, Modal, Select, InputNumber, useSelect, message, Checkbox, Button, Typography } from '@pankod/refine-antd'
import { useGetIdentity, useCreate, useMutationMode, useNavigation } from '@pankod/refine-core'
import { IUser } from 'interfaces'
import { useEffect, useState } from 'react'
import { nhost } from 'utility'
import { getAllRoles, updateUserById } from 'users'
import { } from '@pankod/refine-react-router-v6'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { useUserContext } from 'context/user'
import sendEmail from 'sendmail'
type CreateUserProps = {
  modalProps: ModalProps
  formProps: FormProps
  close: any
  record: any
  refreshData: any
}
export interface ISignup {
  email: string
  password: string
  defaultRole: string
  displayName: string
  user_id: string
  disabled: boolean
  updated_by: any
  roles: string[]
  send_verification: boolean
}
export const UserEdit: React.FC<CreateUserProps> = ({ modalProps, formProps, close, record, refreshData }) => {
  const { data: user } = useGetIdentity()
  let sic_roles = ['qcreator', 'qreviewer', 'qapprover', 'variantcreator']
  const { userRole } = useUserContext()
  const [form] = Form.useForm()
  const [checked, setChecked] = useState(false)
  const [valuePropName, setPropName] = useState('unchecked')
  const [sendVerification, setSendVerification] = useState(false)
  const { push, goBack } = useNavigation()
  const [roleList, setRoleList] = useState([] as any[])
  const [roles, setRoles] = useState<string[]>([])
  const [open, setOpen] = useState(true)
  const [selectedRoles, setSelectedRoles] = useState<string[]>()
  const [defaultRole, setDefaultRole] = useState('')
  let pm_roles = ['qcreator', 'qreviewer', 'qapprover', 'variantcreator', 'subjectincharge', 'papersetter', 'paperapprover']

  useEffect(() => {
    formProps.form?.resetFields()
  })
  useEffect(() => {
    getAllRoles().then((response: any) => {
      setRoleList(response.authRoles)
    })
    setDefaultRole(record?.defaultRole)

    // form.setFieldsValue({ displayName: "", email: "", defaultRole: "" });
  }, [record])
  useEffect(() => {
    if (record?.disabled === true) {
      setPropName('checked')
    }
    let arr: string[] = []
    record?.roles?.map((item: any) => {
      if (item?.role !== 'user' && item?.role !== 'me') arr.push(item?.role)
    })
    setRoles(arr)
    setSelectedRoles(arr)
    // form.setFieldsValue({ displayName: "", email: "", defaultRole: "" });
  }, [record])
  const success = (msg: string, type: string) => {
    if (type === 'success') {
      message.success(msg)
      close()
    } else message.error(msg)
  }
  const handleRoleChange = (value: string[]) => {
    // console.log('hai,,,,,,,,,,,,,,,,,,,')
    setDefaultRole('')

    setSelectedRoles(value)
    setRoles(value)
  }
  const onChange = (e: CheckboxChangeEvent) => {
    setChecked(e.target.checked)
    if (e.target.checked === true) {
      setPropName('checked')
    }
  }
  //   const { mutate: createUser } = useCreate<IUser>();
  return (
    <Modal
      {...modalProps}
      title="Edit User"
      destroyOnClose={true}
      onCancel={() => {
        formProps.form?.resetFields()
        refreshData()
        close()
      }}
    >
      <Form
        //  form={form}
        {...formProps}
        size="large"
        layout="vertical"
        onFinish={values => {
          let user_values: ISignup
          if (values?.roles?.includes('admin')) {
            user_values = {
              displayName: values?.displayName,
              roles: ['admin'],
              defaultRole: 'admin',
              email: values?.email,
              password: values?.password,
              updated_by: values?.updated_by,
              user_id: values?.user_id,
              send_verification: sendVerification,
              disabled: values?.disabled,
            }
          } else {
            user_values = values
          }
          updateUserById(user_values).then(response => {
            refreshData()
            if (response === 'OK') {
              success('User Updated', 'success')
            } else {
              success('Error Occured', 'danger')
            }
          })
          //   refreshData();
        }}
      >
        <Form.Item
          label="Display Name"
          name="displayName"
          initialValue={record?.displayName}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Role" name="roles" rules={[{ required: true }]} initialValue={roles}>
          <Select
            mode="multiple"
            onChange={handleRoleChange}
            //  open={open}
            onDropdownVisibleChange={visible => setOpen(visible)}
            dropdownRender={menu => (
              <div>
                {menu}

                <Button size="small" type="primary" onClick={() => setOpen(false)} style={{ position: 'absolute', right: 10, top: 5 }}>
                  Close
                </Button>
              </div>
            )}
          >
            {roleList.length > 0 &&
              roleList?.map(item =>
                userRole === 'subjectincharge' ? (
                  sic_roles.includes(item?.role) && item?.role !== 'user' && item?.role !== 'me' ? (
                    <option key={item?.role} value={item?.role}>
                      {item?.role}
                    </option>
                  ) : null
                ) :
                  userRole === 'productmanager' ? (
                    pm_roles.includes(item?.role) ? (
                      <option key={item?.role} value={item?.role}>
                        {item?.role}
                      </option>
                    ) : null
                  )


                    : (
                      item?.role !== 'user' &&
                      item?.role !== 'me' && (
                        <option key={item?.role} value={item?.role}>
                          {item?.role}
                        </option>
                      )
                    )
              )}
          </Select>
          {/* <Select />{" "} */}
        </Form.Item>
        <Form.Item
          label="Primary Role"
          name="defaultRole"
          rules={[{ required: selectedRoles?.includes('admin') ? false : true }]}
          initialValue={defaultRole}
        >
          <Select disabled={selectedRoles?.includes('admin')}>
            {selectedRoles?.map((item: any) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </Select>
        </Form.Item>
        {selectedRoles?.includes('admin') === true ? (
          <Typography.Text type="warning">Admin has all permissions. No need to select multiple roles</Typography.Text>
        ) : null}
        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              type: 'email',
            },
          ]}
          initialValue={record?.email}
        >
          <Input placeholder="Email" disabled={record?.emailVerified ? true : false} onChange={() => setSendVerification(true)} />
        </Form.Item>
        <Form.Item
          label="Active"
          name="disabled"
          valuePropName={valuePropName}
          //   valuePropName="checked"
          rules={[
            {
              required: false,
            },
          ]}
          initialValue={record?.disabled}
        >
          <Checkbox onChange={onChange}>Deactivate</Checkbox>
        </Form.Item>
        <Form.Item name="user_id" initialValue={record?.id}>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item name="send_verification" initialValue={sendVerification}>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item name="updated_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
